<button type="button"
        class="mat-icon-button"
        (click)="delete()"
        fxFlexAlign="center center"
        [disabled]="params?.api?.rowEdit?.isDeleteDisabled">
  <mat-icon class="material-icons">delete</mat-icon>
</button>
